import { useEffect, useState } from "react";
import { api } from "../api/client.ts";

interface Purchase {
  id: string;
  userId: string;
  kind: "pack" | "bundle";
  amountThb: number;
  status: string;
  paidAt?: string;
  createdAt: string;
}

export function SalesPage() {
  const [items, setItems] = useState<Purchase[]>([]);
  useEffect(() => {
    // /api/admin/purchases isn't implemented yet — defer with empty state
    void (async () => {
      try {
        const data = await api.get<{ items: Purchase[] }>("/api/admin/purchases");
        setItems(data.items);
      } catch {
        setItems([]);
      }
    })();
  }, []);
  return (
    <div className="space-y-4">
      <h1 className="font-heading text-3xl font-bold">Sales</h1>
      {items.length === 0 ? (
        <p className="text-sm text-[var(--brand-muted)]">
          Sales table comes online once /api/admin/purchases lands. Until then, see Stripe
          Dashboard.
        </p>
      ) : (
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-[var(--brand-muted)]">
              <th className="py-2">Ref</th>
              <th>Kind</th>
              <th>Amount</th>
              <th>Status</th>
              <th>Paid at</th>
            </tr>
          </thead>
          <tbody>
            {items.map((p) => (
              <tr key={p.id} className="border-t border-[var(--brand-border)]">
                <td className="py-2 font-mono text-xs">{p.id}</td>
                <td>{p.kind}</td>
                <td>฿{p.amountThb}</td>
                <td>{p.status}</td>
                <td>{p.paidAt ?? "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
